






















































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import {IFormControl, IListItem} from '@/entities';
import {parsePeriodListItem, refactorToPeriodStartListItem, refactorToPeriodEndListItem} from '@/utils';

@Component({})
export default class DateRangeWeeklyEx extends Vue {
    @Prop() public dateRangeHints: IListItem[];
    @Prop() public dateRange: IFormControl;

    public dateRangeHint: IFormControl = {
        key: 'dateRangeHintId',
        label: 'start - end',
        value: null
    };

    private get dateRangeStartHints(): IListItem[] {
        const dateRangeStartHints: IListItem[] = [];
        this.dateRangeHints.map((item: IListItem) => {
            const itemPeriod = parsePeriodListItem(item.value);
            if (itemPeriod.start < this.dateRange.value.end) {
                dateRangeStartHints.push(refactorToPeriodStartListItem(itemPeriod));
            }
        });
        return dateRangeStartHints;
    }

    private get dateRangeEndHints(): IListItem[] {
        const dateRangeEndHints: IListItem[] = [];
        this.dateRangeHints.map((item: IListItem) => {
            const itemPeriod = parsePeriodListItem(item.value);
            if (this.dateRange.value.start < itemPeriod.end) {
                dateRangeEndHints.push(refactorToPeriodEndListItem(itemPeriod));
            }
        });
        return dateRangeEndHints;
    }

    private get dateRangePeriods(): IListItem[] {
        return [
            {
                heading: 'Choose period',
                value: null,
            } as IListItem,
            ...this.dateRangeHints,
        ];
    }
}
